// 运行环境判断
const hostname = window.location.hostname

let runenv =
  {
    'http://server.wwforu.com': 'prod'
  }[hostname] || 'prod'

if (process.env.NODE_ENV === 'develop') {
  runenv = 'local'
}

const ENV = {
  wwwURL: 'http://server.wwforu.com/',
  version: '1.0',
  environment: process.env.NODE_ENV,
  defaultLocale: 'zh',
  wxAppId: 'wxd64a7c21edfd106d',
  wxScope: 'snsapi_login',
  runenv,
  qrcssUrl: 'https://emilyzhou.gitee.io/ww-qrcss/qrcode.css'
}

export default ENV
